module.exports = __webpack_public_path__ + "img/thermometer.5d1be065.svg";